export var ValidateText = function ValidateText(text, length) { if (length) {
    if (!text.replace(/\s/g, "").length || text.length > length)
        return false;
    return true;
} if (!text.replace(/\s/g, "").length)
    return false; return true; };
